import { createIcon } from '@chakra-ui/react';

export const ArrowUpIcon = createIcon({
  displayName: 'ArrowUpIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        d="M18.0697 9.57L11.9997 3.5L5.92969 9.57"
        stroke="#8877CE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20.4999V3.66992"
        stroke="#8877CE"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
});
